import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-planning-insights.light.webp";
import imageDark from "../images/national-planning-insights.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-planning-insights",
  displayName: `National Planning Insights`,
  datasetProductCode: `GEOSCAPE PLANNING INSIGHTS - BASE`,
  subtitle: `Advanced Zoning and Planning Classification for Development.`,
  shortDescription: `Planning Insights is a comprehensive representation of planning zone and overlay information applicable to land parcels and addresses across Australia. Planning Insights aims to provide insights to enable a greater understanding of how land can be developed and to inform about limitations and specific characteristics of planning sites.
Planning Insights is designed to meet the needs of organisations that require a representation of zoning and overlay information for land parcels and addresses at both a local and broad scale. The attribution provided within Planning Insights allows for the application of the data across a wide range of commercial, government and research use.`,
  metadata: {
    dateAdded: 1680220800000,
    dataType: ["Aspatial"],
    totalFeatureCount: 11054548,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/planning_insights.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/planning_insights.html`,
  imageLight,
  imageDark,
  searchTags: `National Planning Insights Geoscape Planning Insights Development Potential Planning Classification Property Insights Strategy Urban Analysis Urban Infrastructure Urban Planning Urbanism Zoning Insights`,
  detail: () =>
    import("../details/national-planning-insights").then((m) => m.detail),
};

export default entry;
